import util from "@bmp-vue/core/api/util";

const controller = "ArquivoRetorno";
export default Object.assign({}, util.GetCrud(controller, ["getall", "get"]), {
  GetAllPendenteProcessamento: function(dto) {
    return util.Axios.GetAll(controller + "/pendentes", dto);
  },
  Reprocessar: function (dto){
    return util.Axios.Post(controller + "/reprocessar", dto);
  }
});
